namespace Areas.Account.Workflows {
    "use strict";

    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.workflowId; },
            "<a href= 'https://documentmanagement.capnet.ucla.edu/Workflows/View/Index/{placeholder}' target=\"_blank\">View</a>");
    }


    export function cellPreparedPivotGrid(e: any) {
        if (isWorkflowNameColumn(e) || isWorkflowLinkColumn(e) || isWorkflowDateColumn(e)) {
            const workflowLink = e.cell.text;
            e.cellElement.html(workflowLink);
        } else if (isWorkflowDetailIdColumn(e)) {
            e.cellElement.html("");
        }
        else if (isDataColumn(e)) {
            setContent(e);
        }
    }

    export function calculateSummaryValue(args) {
        if (args.field("row")) {
            if (args.field("row").dataField === "workflowName"
                || args.field("row").dataField === "projectName"
                || args.field("row").dataField === "displayDueDate"
                ) {
                return "";  //Show blank on the workflowName and projectName summary row
            }
            else {
                return args.value("html") || "";    //Return an empty string if value is null to prevent cell from being hidden
            }
        }
    }

    function isWorkflowNameColumn(e: any): boolean {
        return e.area === "row" && e.cell.path && e.cell.path.length === 2;
    }

    function isWorkflowDateColumn(e: any): boolean {
        return e.area === "row" && e.cell.path && e.cell.path.length === 3;
    }

    function isWorkflowLinkColumn(e: any): boolean {
        return e.area === "row" && e.cell.path && e.cell.path.length === 4;
    }

    function isWorkflowDetailIdColumn(e: any): boolean {
        return e.area === "row" && e.cell.path && e.cell.path.length === 5;
    }

    function isDataColumn(e: any): boolean {
        return e.area === "data" && e.cell.text !== "undefined" && e.cell.text !== "";
    }

    function setContent(e: any) {
        const data = e.cell.text.split("|");
        const [user, actionTaken, dateActionTaken] = data;
        let content = user + "<br>" + actionTaken;

        if (dateActionTaken) {
            const date = new Date(dateActionTaken);

            content = content + "<br>" + formatDateTime(date);
        }

        if (!dateActionTaken) {
            e.cellElement.css("background-color", "#fafad2" );
        }

        e.cellElement.html(content);
    }

}